import React from "react";

export interface IEventTimeFormatProps {
  time: Date;
}

// This atom is for displaying time like 10a, 10:35a
const EventTimeFormat: React.FC<IEventTimeFormatProps> = (props) => {
  // @ts-ignore
  let formatter = new Intl.DateTimeFormat("en-nz", {timeStyle: "short"});
  let displayTime = formatter
    .formatToParts(props.time)
    .map(({type, value}) => {
      switch (type) {
        case "literal":
          if (
            value === " " ||
            (value === ":" && props.time.getMinutes() === 0)
          ) {
            return "";
          }
          return value;
        case "minute":
          return props.time.getMinutes() === 0 ? "" : value;
        case "dayPeriod":
          return value;
        default:
          return value;
      }
    })
    .join("");

  return <>{displayTime}</>;
};

export default EventTimeFormat;
